import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AnnualReportBusinessModel } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AnnualReportTemplatesProvider } from '../../../provider/annual-report-templates.provider';

@UntilDestroy()
@Component({
    selector: 'aumico-lib-ar-templates-pdf-page',
    templateUrl: './ar-templates-pdf.page.html',
    styleUrls: ['./ar-templates-pdf.page.scss'],
})
export class ArTemplatesPdfPageComponent implements OnInit {
    private uploadedFile: File | null = null;

    @Input() savedPdfTemplateId: string | null;
    @Input() savedPdfTemplateName: string | null;
    @Input() businessModel: AnnualReportBusinessModel | undefined;
    @Output() uploadFileChanged: EventEmitter<FormData | null> = new EventEmitter<FormData | null>();
    @Output() resetTemplateToDefaultClicked: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private annualReportTemplatesProvider: AnnualReportTemplatesProvider,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {
        this.addSvgIcon('aumico-pattern-xls-file-icon-purple');
    }

    ngOnInit(): void {}

    public onFileUploadedChanged(event): void {
        this.uploadedFile = event;
        if (this.uploadedFile) {
            const formData: FormData = new FormData();
            formData.append('file', this.uploadedFile, this.uploadedFile.name);
            this.savedPdfTemplateName = this.uploadedFile.name;
            this.uploadFileChanged.emit(formData);
        } else {
            this.savedPdfTemplateId = null;
            this.savedPdfTemplateName = null;
            this.uploadFileChanged.emit(null);
        }
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    public downloadPdfTemplate(): void {
        if (this.uploadedFile) {
            this.downloadPdfThatIsNotSaved();
        } else if (this.savedPdfTemplateId != null) {
            this.annualReportTemplatesProvider.downloadPdfTemplate(this.savedPdfTemplateId);
        } else if (this.businessModel === AnnualReportBusinessModel.HGB) {
            this.annualReportTemplatesProvider.downloadDefaultHgbPdfTemplate();
        } else {
            this.annualReportTemplatesProvider.downloadDefaultPdfTemplate();
        }
    }

    public resetTemplateToDefault(): void {
        this.resetTemplateToDefaultClicked.emit();
    }

    private downloadPdfThatIsNotSaved(): void {
        const blob = new Blob([this.uploadedFile], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.uploadedFile.name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }
}
